module.exports = __webpack_public_path__ + "stockLibrary/simulator/008-cbf9436ba4a19abfa91171b0f286cc27.png";